import axios from 'axios';
import { variablesGlobales } from '../../configs/variables';

export class FunnelService {

    static async getFunnel(url) {
        try {
            const responseServer = await axios.get(url);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data?.message,
                date: new Date(),
                code: error.code,
                status: error?.response?.status
            }
        }
    }

    static async addTimeline(funnelId = '', data = {}) {
        try {
            const responseServer = await axios.put(`${variablesGlobales.urlServiceBackend}/api/v1/funnel/addTimeline/${funnelId}`, data);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data?.message,
                date: new Date(),
                code: error.code,
                status: error?.response?.status
            }
        }
    }

    static async addTimelineByOperationId(operationId = '', data = {}) {
        try {
            const responseServer = await axios.put(`${variablesGlobales.urlServiceBackend}/api/v1/funnel/addTimelineByOperationId/${operationId}`, data);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data?.message,
                date: new Date(),
                code: error.code,
                status: error?.response?.status
            }
        }
    }

    static async addTimelineByCreditId(creditId = '', data = {}) {
        try {
            const responseServer = await axios.put(`${variablesGlobales.urlServiceBackend}/api/v1/funnel/addTimelineByCreditId/${creditId}`, data);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response.data?.message,
                date: new Date(),
                code: error.code,
                status: error?.response?.status
            }
        }
    }
}